export const SET_USERS = "SET_USERS";
export const GET_USERS = "GET_USERS";
export const REFRESH_USERS = "REFRESH_USERS";
export const UPDATE_FEATURE = 'UPDATE_FEATURE';